import { useLazyQuery, useQuery } from "@apollo/client";
import { SENTINELS } from "../sentinels.queries";
import {
  SentinelsQuery,
  SentinelsQueryVariables,
} from "../../../__generated__/SentinelsQuery";

export const useSentinels = (variables: SentinelsQueryVariables) => {
  return useQuery<SentinelsQuery, SentinelsQueryVariables>(SENTINELS, {
    variables,
  });
};

export const useLazySentinels = () => {
  return useLazyQuery<SentinelsQuery, SentinelsQueryVariables>(SENTINELS);
};
